import type {
  UserProfile,
  WorkspaceInfo,
  WorkspaceMember,
  Session,
  ApiKey,
  Integration,
} from "./types";

export const currentUser: UserProfile = {
  name: "Sarah Chen",
  email: "sarah.chen@auditco.com",
  jobTitle: "Lead Auditor",
  avatarColor: "#E8734A",
  timezone: "America/New_York",
};

export const workspaceInfo: WorkspaceInfo = {
  name: "AuditCo",
  domain: "auditco.audit-app.com",
};

export const workspaceMembers: WorkspaceMember[] = [
  {
    id: "1",
    name: "Sarah Chen",
    email: "sarah.chen@auditco.com",
    role: "owner",
    status: "active",
    avatarColor: "#E8734A",
    joinedAt: "Jan 15, 2024",
  },
  {
    id: "2",
    name: "Marcus Weber",
    email: "marcus.weber@auditco.com",
    role: "admin",
    status: "active",
    avatarColor: "#8B5CF6",
    joinedAt: "Mar 22, 2024",
  },
  {
    id: "3",
    name: "Ayumi Tanaka",
    email: "ayumi.tanaka@auditco.com",
    role: "member",
    status: "active",
    avatarColor: "#10B981",
    joinedAt: "Jun 10, 2024",
  },
  {
    id: "4",
    name: "James Wilson",
    email: "james.wilson@auditco.com",
    role: "member",
    status: "active",
    avatarColor: "#F59E0B",
    joinedAt: "Aug 5, 2024",
  },
  {
    id: "5",
    name: "Elena Rodriguez",
    email: "elena.r@auditco.com",
    role: "viewer",
    status: "pending",
    avatarColor: "#EC4899",
    joinedAt: "Jan 20, 2025",
  },
];

export const sessions: Session[] = [
  {
    id: "1",
    device: "MacBook Pro",
    browser: "Chrome 121",
    location: "New York, US",
    lastActive: "Now",
    current: true,
  },
  {
    id: "2",
    device: "iPhone 15",
    browser: "Safari",
    location: "New York, US",
    lastActive: "2 hours ago",
    current: false,
  },
  {
    id: "3",
    device: "Windows Desktop",
    browser: "Firefox 122",
    location: "Chicago, US",
    lastActive: "3 days ago",
    current: false,
  },
];

export const apiKeys: ApiKey[] = [
  {
    id: "1",
    name: "CI/CD Pipeline",
    prefix: "ak_live_7Hx9...mP2q",
    createdAt: "Jan 15, 2026",
    lastUsed: "2 hours ago",
  },
  {
    id: "2",
    name: "Reporting Dashboard",
    prefix: "ak_live_3Kd4...nR8w",
    createdAt: "Nov 28, 2025",
    lastUsed: "5 days ago",
  },
];

export const integrations: Integration[] = [
  {
    id: "1",
    name: "Slack",
    description: "Get audit notifications in Slack channels",
    connected: true,
    category: "Communication",
    color: "#E01E5A",
  },
  {
    id: "2",
    name: "Jira",
    description: "Sync findings with Jira issues",
    connected: true,
    category: "Project Management",
    color: "#0052CC",
  },
  {
    id: "3",
    name: "Google Drive",
    description: "Import documents from Google Drive",
    connected: false,
    category: "Storage",
    color: "#FBBC04",
  },
  {
    id: "4",
    name: "Microsoft Teams",
    description: "Get notifications in Teams channels",
    connected: false,
    category: "Communication",
    color: "#6264A7",
  },
  {
    id: "5",
    name: "SharePoint",
    description: "Sync documents with SharePoint",
    connected: false,
    category: "Storage",
    color: "#038387",
  },
  {
    id: "6",
    name: "Confluence",
    description: "Export audit reports to Confluence",
    connected: false,
    category: "Documentation",
    color: "#1868DB",
  },
];
